module.exports = __webpack_public_path__ + "img/Board_DT.c19c52ff.png";